export const examples = [
  {
    id: 1,
    name: "Example 1",
    slug: "example1",
    description: "a tRNA sequence, default mode",
    helpUrl: "/help#example1",
    data: {
      rna_sequence: "GGGCGGCUAGCUCAGCGGAAGAGCGCUCGCCUCACACGCGAGAGGUCGUAGGUUCAAGUCCUACGCCGCCCACCA",
      reactivities: "",
      restraints: "",
      reference: "",
      alignment: "",
      parameters: {
        tl: 5,
        cl: 1,
        rfam: true,
        g4: true,
        rbp: true,
        showParameters: false
      }
    }
  },
  {
    id: 2,
    name: "Example 2",
    slug: "example2",
    description: "Telomerase pseudoknot with residue reactivities",
    helpUrl: "/help#example2",
    data: {
      rna_sequence: "GGGCUGUUUUUCUCGCUGACUUUCAGCCCAACACAAAAAAAGUCAGC",
      reactivities: "-0.036\t-0.026\t-0.02\t0.068\t-0.055\t-0.127\t0.084\t0.228\t1.005\t0.316\t0.995\t0.062\t-0.032\t-0.084\t-0.104\t-0.084\t-0.078\t0.338\t-0.049\t-0.107\t-0.117\t-0.241\t0.175\t0.081\t-0.163\t0.049\t0.862\t0.007\t0.059\t1.769\t0.049\t-0.026\t-0.309\t0.465\t0.322\t0.358\t0.254\t0.059\t1.158\t1.197\t0.088\t0.055\t-0.537\t-0.241\t-0.032\t0.075\t0.293",
      restraints: "",
      reference: "",
      alignment: "",
      parameters: {
        tl: 5,
        cl: 1,
        rfam: true,
        g4: true,
        rbp: true,
        showParameters: false
      }
    }
  },
  {
    id: 3,
    name: "Example 3",
    slug: "example3",
    description: "HDV ribozyme with sequence alignment and reference structure",
    helpUrl: "/help#example3",
    data: {
      rna_sequence: "AUGGCCGGCAUGGUCCCAGCCUCCUCGCUGGCGCCGGCUGGGCAACAUUCCGAAGGGGACCGUCCCUCGGUAAUGGCGAAUGGGACCCA",
      reactivities: "",
      restraints: "",
      reference: "..(((((((..[[[[[[[(((.[[.....))))))))))]]....((((((((.(((.(...)))))))).)))).....]]]]]]]..",
      alignment: `>seq
AUGGCCGGCAUGGUC-CCA--------GCCUCCUCGCUGGCGCCGGCUGGGCAACAUUCCGAA-GGGGA-CCG--U---CC-C----UC--GGUAAUGGCGAA---UGGGACCCA
>RF00094__X04451_1_684_772
AUGGCCGGCAUGGUC-CCA--------GCCUCCUCGCUGGCGCCGGCUGGGCAACAUUCCGA--GGGGA-CCG--U--CCC-C----UC--GGUAAUGGCGAA---UGGGACCCA
>RF00094__AJ584845_1_918_825
UCGGGUCGGCAUGGCAUCUCC------ACCUCCCCGC-GGUCCGACCUGGG---CAU-CCGAA-GGAGGACAGAAC--GUC-C--ACUC--GG--AUGGCUAAGGGAGAGCCAGU
>RF00094__AJ309880_1_911_818
UCGGGUCGGCAUGGCAUCUCC------ACCUCCUCGC-GGUCCGACCUGGG---CAUCCGUA--GGAGGACAG-AC--GUC-C----UACUCG-GAUGGCUAAGGGAGAGCCAGU
>RF00094__EF514905_2_675_762
GUGGCCGGCAUGGU--CCA--------GCCUACUCGCUGGCGCGGGCUGGGCAACAUUCCGA--GGGGA-CCC--G--UCC-C----UC--GGUAAUGGCGAA---UGGGACCCA
>RF00094__L22063_1_906_814
UCGGGUCGGCAUGGGAUCUCC------ACCUCCUCGC-GGUCCGACCUGGG---CAU-CCGUAAGGAGA-GCG--UAGCUC-C---CUC--GG--AUGGCAAAGGGAGAUCCACC
>RF00094__AB221936_1_165_71
UCGGGUCGGCAUGGCAUCUCC------ACCUCCUCGC-GGUCCGACCUGGG---CAU-CCGUA-GGAGG-ACGAAC--GUC-CUACCUC--GG--AUGGCUAAGGGAGAGCCAGU
>RF00094__AB118827_1_904_812
UCGGGUCGGCAUGGCAUCUCC------ACCUCCCCGU-GGUCCGACCUGGG---CAU-CCGAA-GGAGG-ACAAAC--GUC-C--ACUC--GG--AUGGCUAAGGGAGAGCCAGU
>RF00094__AM183327_1_684_771
GUGGCCGGCAUGGUC-CCA--------GCCUCCUCGCUGGCGCCGGCUGGGCAACAUUCCGA--GGGGA-CCG--U---CC-C----CC--GGUAAUGGCAGA---UGGGACCCA`,
      parameters: {
        tl: 5,
        cl: 1,
        rfam: true,
        g4: true,
        rbp: true,
        showParameters: false
      }
    }
  },
  {
    id: 4,
    name: "Example 4",
    slug: "example4",
    description: "G-quadruplex & protein-binding motif",
    helpUrl: "/help#example4",
    data: {
      rna_sequence: "GCGCCAUAAACGCGAAACACGCGAAAGGGCCAUUGGGUGGGAUCUGGGAUGGCGC",
      reactivities: "",
      restraints: "",
      reference: "",
      alignment: "",
      parameters: {
        tl: 5,
        cl: 1,
        rfam: true,
        g4: true,
        rbp: true,
        showParameters: false
      }
    }
  },
  {
    id: 5,
    name: "Example 5",
    slug: "example5",
    description: "Two RNA chains with restraints",
    helpUrl: "/help#example5",
    data: {
      rna_sequence: "GGGGGAAAACCCCCAAA;AAAGGGGGAAAACCCCC",
      reactivities: "",
      restraints: "........./////...;.................",
      reference: "",
      alignment: "",
      parameters: {
        tl: 5,
        cl: 1,
        rfam: true,
        g4: true,
        rbp: true,
        showParameters: false
      }
    }
  }
];
